import styled from "styled-components";

export const SlideoutContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
	padding-top: 24px;
`;

export const SlideoutHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	
 & > div:nth-child(2) > div {
	 border-radius: 8px;
	 border-color: ${(props) => props.theme.colors.davysGrey};
 }
`;

export const SlideoutSubHeader = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`;

export const SlideoutContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	max-height: calc(100vh - 380px);
	
	& > div {
    padding: 0px 8px 0px 0px;
	}
`;

export const SlideoutActions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 8px;
	bottom: 0;
`;

export const SlideoutDrivesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
	
	& > div > button, & > div > button:hover, & > div > button:active {
		flex:1;
    justify-content: center;
	}
`;

export const BackButtonWrapper = styled.div`
	display: flex;
	cursor: pointer;
`;

